// @ts-check

export const forgotPasswordPath = "/forgot-password";
